import React from "react";
import { getCardImage } from "../resultVisuals/cardAssets";

const WINNER_IMG = `${import.meta.env.BASE_URL}img/winner.png`;

function PlayerCards({ name, cards, isWinner }) {
  return (
    <div className="casino-result-content-item text-center">
      <h4>{name}</h4>{" "}
      <div className="casino-result-cards">
        {isWinner && (
          <div className="casino-result-cards-item">
            <img src={WINNER_IMG} className="winner-icon" alt="" />
          </div>
        )}
        {cards.map((c, i) => (
          <React.Fragment key={i}>
            {" "}
            <div className="casino-result-cards-item">
              <img src={getCardImage(c)} alt="" />
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

/**
 * Reference result body for Teenpatti - 2.0 (teen6): cards A=[0,2,4], B=[1,3,5], trophy before the
 * winner's cards, and rdesc "winner#suit#odd-even#cards#under-over" shown as
 * Winner / Suit / Odd/Even / Cards / Under/Over.
 */
export default function Teen6ResultBody({ t1 }) {
  const cards = String(t1?.card || "").split(",").map((c) => c.trim()).filter(Boolean);
  const a = [0, 2, 4].map((i) => cards[i]).filter(Boolean);
  const b = [1, 3, 5].map((i) => cards[i]).filter(Boolean);
  const win = String(t1?.win ?? "");
  const desc = t1?.rdesc ? String(t1.rdesc).split("#") : [];
  const row = (label, value) => (
    <div className="casino-result-desc-item">
      <div>{label}</div> <div>{value}</div>
    </div>
  );

  return (
    <div className="row row5">
      {cards.length > 0 && (
        <div className="col-12 col-lg-7">
          <div className="casino-result-content">
            <PlayerCards name="Player A" cards={a} isWinner={win === "1"} />{" "}
            <div className="casino-result-content-diveder" />{" "}
            <PlayerCards name="Player B" cards={b} isWinner={win === "2"} />
          </div>
        </div>
      )}{" "}
      <div className="col-12 col-lg-5">
        {desc.length > 0 && (
          <div className="casino-result-desc">
            {row("Winner", desc[0])}{" "}
            {row("Suit", desc[1])}{" "}
            {row("Odd/Even", desc[2])}{" "}
            {row("Cards", desc[3])}{" "}
            {row("Under/Over", desc[4])}
          </div>
        )}
      </div>
    </div>
  );
}
